<script setup lang="ts">
interface Props {
  title: string;
  subtitle?: string;
  icon?: 'user' | 'chart' | 'menu' | 'info';
}

withDefaults(defineProps<Props>(), { subtitle: '', icon: 'user' });
</script>

<template>
  <header class="flex items-center gap-2 mb-lg">
    <div class="w-10 h-10 rounded-medium bg-brand-100 flex items-center justify-center text-text-secondary">
      <svg v-if="icon === 'user'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
      <svg v-else-if="icon === 'chart'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="20" x2="12" y2="10" />
        <line x1="18" y1="20" x2="18" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
      <svg v-else-if="icon === 'menu'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="3" y1="18" x2="21" y2="18" />
      </svg>
      <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="16" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
      </svg>
    </div>
    <slot name="leading" />
    <span class="text-title-large font-semibold text-text-primary flex-1 min-w-0">{{ title }}</span>
    <slot name="trailing" />
  </header>
</template>
